import { useEffect, useRef, useState } from "react";
import styles from "./NextVisit.module.scss";
import { trackEvent } from "../utils/helpers";

export default function AnimatedBorderContainer({ heading, description, onButtonClick, slideFromRight = false }) {
  const containerRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(() => setIsVisible(true), 200);
          observer.disconnect();
        }
      },
      { threshold: 1 },
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <div className={`${styles.ctaOuterContainer} section`}>
      <div className={styles.ctaContainer}>
        <div className={styles.content}>
          <div className={`${styles.topSection} shareLinkWrapper`}>
            <h2>Next round?</h2>
            <h3>beat your score</h3>
            <span className={styles.divider} aria-hidden="true" />
            <a
              href="https://electricshuffle.com/"
              target="_blank"
              rel="noreferrer"
              className="shareLink"
              onClick={() => trackEvent("Next Visit", "start_a_booking")}
            >
              Start a booking
            </a>
          </div>
          <div className={styles.bottomSection} ref={containerRef}>
            <span className={styles.count}>5</span>
            <img
              src={"./img/puck-booking.svg"}
              className={`${styles.puck} ${slideFromRight ? styles.puckRight : ""} ${isVisible ? ` ${styles.puckVisible}` : ""}`}
              alt=""
              aria-hidden="true"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
